export default {
  DefaultImplicitSetting: {
    Text: {
      BudgetChapter: 'Chương',
      BudgetSource: 'Nguồn kinh phí',
      BudgetKind: 'Khoản',
      Fund: 'Quỹ tiền',
      Major: 'Nghiệp vụ',
      MaCTMT: 'Mã CTMT',
      BudgetItem: 'Lấy diễn giải là tên tiểu mục',
      DisplayBudgetChapter: 'Hiển thị chương tạm ứng',
      DisplayBudgetKind: 'Hiển thị khoản tạm ứng',
      UpdateDetailDescriptionByMasterDescription: 'Cập nhật diễn giải chi tiết theo diễn giải chung',
      
    },
  },
};
